module.exports = __webpack_public_path__ + "static/media/CircleOffNew.857968f2.svg";